import type { AuthUser } from '@/shared/types/auth';

function asText(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

function looksLikeEmail(value: string): boolean {
  return value.includes('@');
}

/** Show first/last or name only — never email. */
export function getUserDisplayName(
  user: AuthUser | null | undefined,
  fallback = 'NA',
): string {
  if (!user) return fallback;

  const firstName = asText(user.firstName);
  const lastName = asText(user.lastName);
  const full = [firstName, lastName].filter(Boolean).join(' ').trim();
  if (full) return full;

  const name = asText(user.name);
  if (name && !looksLikeEmail(name)) return name;

  return fallback;
}

export function getUserFirstName(
  user: AuthUser | null | undefined,
  fallback = 'there',
): string {
  const firstName = asText(user?.firstName);
  if (firstName) return firstName;

  const display = getUserDisplayName(user, fallback);
  if (!display || display === fallback) return fallback;
  return display.split(/\s+/)[0] || fallback;
}

export function getUserInitial(
  user: AuthUser | null | undefined,
  fallback = 'U',
): string {
  const firstName = asText(user?.firstName);
  const lastName = asText(user?.lastName);
  if (firstName || lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || fallback;
  }
  return getUserDisplayName(user, fallback).charAt(0).toUpperCase() || fallback;
}
